import React from "react";
import Box from "@mui/material/Box";
import { CustomButton } from "../../../../../components/customButton/CustomButton";

export function TabIndicacionHeader({ handleOpenDialog, disabled }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <h3>Indicación</h3>
      <Box display="flex" gap="20px">
        <CustomButton
          label={"Historial"}
          variant="outlined"
          onClick={() => handleOpenDialog("showHistory")}
        />
        <CustomButton
          label={"Solicitar"}
          disabled={disabled}
          onClick={() => handleOpenDialog("addIndication")}
        />
      </Box>
    </Box>
  );
}
